<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Day Summary</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home/dashboard"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>        </div>
      </div>
      <!-- breadcrumb End -->
      <!-- START FORM VALIDATION STATES -->
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Day Summary</span>
        </div>
        <div class="Reports_form_div">
          <form role="form" name="addmapdevice" [formGroup]="registerForm">
            <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
              <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="loginPersonType == 'EMPLOYEE'">
                <mat-label>Business Name</mat-label>
                <!-- search box powered by mat‑autocomplete -->
                <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                       placeholder="Search business" (keyup)="filterBusinesses($event)"
                       (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities"
                       [matAutocomplete]="businessAuto"/>
                <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                  <mat-option *ngFor="let option of filteredOptions" [value]="option">
                    {{ option.businessName }}
                  </mat-option>
                </mat-autocomplete>
                <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
                <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                  <i *ngIf="f.businessfield.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100" *ngIf="loginPersonType == 'Provider Manager'">
                <mat-label>Technician</mat-label>
                <mat-select id="businessfield" formControlName="businessfield" name="businessfield" (click)="isDropdownOpen = false"
                            [(ngModel)]="pondCulture.person_id" (selectionChange)="getFarmSitesByTechnicianId()">
                  <mat-option value="undefined" disabled>Select Technician</mat-option>
                  <mat-option *ngFor="let tech of persons" [value]="tech.id">
                    {{ (tech?.firstName) }} {{tech.lastName}}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.businessfield.invalid"><i>Select technician</i></mat-hint>
                <mat-hint *ngIf="f.businessfield.valid"><i>Technician selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                  <i *ngIf="f.businessfield.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Farm Site</mat-label>
                <mat-select id="location" formControlName="locationField" name="location" (click)="isDropdownOpen = false"
                            [(ngModel)]="pondCulture.farm_site_id" (selectionChange)="getSetionsByFarmsiteId(pondCulture.farm_site_id)">
                  <mat-option value="undefined" disabled>Select Farm site</mat-option>
                  <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                    {{ (farmsite?.farmNameAtLocation) }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
                <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
                <mat-error *ngIf="(submitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                  <i *ngIf="f.locationField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Date</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="date" [formControl]="transactionDateControl" [value]="formattedDate" placeholder="Choose date" autocomplete="off" readonly 
                [max]="maxDate"/>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>
          </form>
          <div class="buttons-div reports_search_div">
            <div class="transactions-button-container" (click)="daySummary()">
              <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
                <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
                <span class="text">Search</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="responseLoader">
          <div class="adjust loader-container">
            <div class="loader2"></div>
          </div>
        </div>
         <div class="reports_block" *ngIf="!responseLoader && isSubmitClicked && pondCultures?.length > 0">
          <div class="actions-container">
            <div class="search-div">
              <img src="../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (keyup)="onFiltersApplied()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by section name and tank name">
              <button *ngIf="this.search != ''"  type="button" (click)="clearFilters('search')" title="clear search" class="searchClose">&times;</button>
            </div>
            <div class="filter_selection_div">
              <div style="position: relative;">
                <button class="filter_button" (click)="onFilterChange()">{{isSectionSelected || isPondSelected || isDateRangeSelected ? 'Clear Filters' : 'Apply Filters'}}</button>
                <button *ngIf="(isSectionSelected || isPondSelected || isDateRangeSelected) || filterType == ''" type="button" (click)="clearFilters('')" title="clear Filters" class="searchClose filtersCloseBlock ">&times;</button>
              </div>
            </div>
            <div class="action-icons" *ngIf="pondCulturesList?.length > 0">
              <img src="../../../../assets/images/New_Icons/excel-download-icon.svg" title="Excel downlaod" (click)="exportExcel()">
              <img src="../../../../assets/images/New_Icons/expand-icon.svg" title="Zoom in" (click)="openFullScreen()">
            </div>
          </div>
          <div class="reports-form-container" *ngIf="filterType == ''" >
            <!--Section selection-->
            <div class="form-field custom-select">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Section</mat-label>

                <mat-select
                  [(ngModel)]="pondCulture.section_id"
                  name="section"
                  (selectionChange)="onSectionSelectionChange($event.value)"
                >
                  <mat-option value="">All sections</mat-option>
                  <mat-option *ngFor="let section of pondSections" [value]="section.id">
                    {{ section.section_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <!--Pond selection-->
            <div class="form-field custom-select" *ngIf="pondCulture.section_id && pondsDetails_dropdown && pondsDetails_dropdown.length > 0">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Pond</mat-label>

                <mat-select
                  [(ngModel)]="pondCulture.pond_id"
                  name="pond"
                  (selectionChange)="onPondSelectionChange($event.value)"
                >
                  <!-- Placeholder / disabled option -->
                  <mat-option [value]="undefined" disabled>Select Pond</mat-option>

                  <!-- Dynamic list -->
                  <mat-option
                    *ngFor="let pond of pondsDetails_dropdown"
                    [value]="pond.pond_id"
                  >
                    {{ pond.pond_name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="table-responsive" id="zoomView" *ngIf="pondCulturesList?.length > 0">
            <table class="table table-striped table-bordered table-hover text-centre">
              <thead>
              <tr>
                <th></th>
                <th colspan="2"></th>
                <th colspan="5">Pond & Stocking</th>
                <th colspan="12">Feed progress</th>
                <th colspan="8"></th>
                <th colspan="2">Weather</th>
              </tr>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Section</th>
                <th>Tank</th>
                <th>Area</th>
                <th>Stocking Count</th>
                <th>Density(pl/m2)</th>
                <th>DOC</th>
                <th>M1(Kgs)</th>
                <th>CTG(Grams)</th>
                <th>CTC(Grams)</th>
                <th>M2(Kgs)</th>
                <th>CTG(Grams)</th>
                <th>CTC(Grams)</th>
                <th>M3(Kgs)</th>
                <th>CTG(Grams)</th>
                <th>CTC(Grams)</th>
                <th>M4(Kgs)</th>
                <th>CTG(Grams)</th>
                <th>CTC(Grams)</th>
                <th>Feed(kg)</th>
                <th>Cumulative Feed</th>
                <th>Treatment Qty</th>
                <th>Treatment Info</th>
                <th>Cumulative Treatment</th>
                <th>SR%</th>
                <th>Biomass(Kgs)</th>
                <th>ABW(Grams)</th>
                <th>Temp Min(<span><sup>o</sup>C</span>)</th>
                <th>Temp Max(<span><sup>o</sup>C</span>)</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let list of pondCulturesList; let i = index">
                <td>{{i+1}}</td>
                <td>{{list.Date | date:"dd MMM yyyy"}}</td>
                <td>{{list.section_name}}</td>
                <td>{{list.Tank}}</td>
                <td>{{list.Area | currencyFormat}} <span *ngIf="list.pondtypeid == 1">Acer</span><span
                  *ngIf="list.pondtypeid == 2">/m<sup>3</sup></span></td>
                <td class="number-align-right">{{list.stocking_count | currencyFormat}}</td>
                <td class="number-align-right">{{list.StockingDensity | currencyFormat}}</td>
                <td class="number-align-right">{{list.DOC}}</td>
                <td class="number-align-right">{{list.Meal1 == null ? 'NA' : list.Meal1}}</td>
                <td class="number-align-right">{{list.Checktraygiven1 == null ? 'NA' : list.Checktraygiven1}}</td>
                <td class="number-align-right">{{list.Checktray1 == null ? 'NA' : list.Checktray1}}</td>
                <td class="number-align-right">{{list.Meal2 == null ? 'NA' : list.Meal2}}</td>
                <td class="number-align-right">{{list.Checktraygiven2 == null ? 'NA' : list.Checktraygiven2}}</td>
                <td class="number-align-right">{{list.Checktray2 == null ? 'NA' : list.Checktray2}}</td>
                <td class="number-align-right">{{list.Meal3 == null ? 'NA' : list.Meal3}}</td>
                <td class="number-align-right">{{list.Checktraygiven3 == null ? 'NA' : list.Checktraygiven3}}</td>
                <td class="number-align-right">{{list.Checktray3 == null ? 'NA' : list.Checktray3}}</td>
                <td class="number-align-right">{{list.Meal4 == null ? 'NA' : list.Meal4}}</td>
                <td class="number-align-right">{{list.Checktraygiven4 == null ? 'NA' : list.Checktraygiven4}}</td>
                <td class="number-align-right">{{list.Checktray4 == null ? 'NA' : list.Checktray4}}</td>
                <td class="number-align-right">{{list.FeedQuantity ?? 'NA'}}</td>
                <td class="number-align-right">{{(list.cumulative_feed == null || list.cumulative_feed == '') ? 'NA' : list.cumulative_feed | currencyFormat}}</td>
                <td class="number-align-right">{{(list.TreatQuantity == '' || list.TreatQuantity == null) ? 'NA' : list.TreatQuantity | currencyFormat}}</td>
                <td class="number-align-right">{{(list.TreatmentData == '' || list.TreatmentData == null) ? 'NA' : list.TreatmentData}}</td>
                <td class="number-align-right">{{list.CummulativeTreatment == null ? 'NA' : list.CummulativeTreatment | currencyFormat}}</td>
                <td class="number-align-right">{{list.survival_rate == null ? 'NA' : list.survival_rate | currencyFormat}}</td>
                <td class="number-align-right">{{(list.Biomass == null) ? 'NA' : list.Biomass | currencyFormat}}</td>
                <td class="number-align-right">{{(list.abw == null || list.abw == '') ? 'NA' : list.abw}}</td>
                <td class="number-align-right">{{list.mintemperature == null ? 'NA' : list.mintemperature}}</td>
                <td class="number-align-right">{{list.maxtemperature == null ? 'NA' : list.maxtemperature}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>

          <div *ngIf="pondCulturesList?.length <= 0" class="noDataFoundMessage">
            {{search != '' && (isSectionSelected || isPondSelected || isDateRangeSelected) ? 'No items match your search and filter' : (search != '' ? 'No items match your search' : 'No items match your filter')}}
          </div>
        </div>
        <div class="reports_block" *ngIf="pondCultures?.length <= 0 && isSubmitClicked">
          <div class="noDataFoundMessage">Data Not Available</div>
        </div>
      </div>
    </div>
  </div>
</div>
